var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1142 2.59778L2.73919 6.34778C2.5459 6.425 2.38017 6.55836 2.26339 6.73066C2.1466 6.90296 2.08412 7.1063 2.08398 7.31444V10.8561L12.5007 6.68944L22.9173 10.8561V7.31444C22.9172 7.1063 22.8547 6.90296 22.7379 6.73066C22.6211 6.55836 22.4554 6.425 22.2621 6.34778L12.8871 2.59778C12.639 2.49866 12.3623 2.49866 12.1142 2.59778Z",
    fill: "#B2B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08398 12.9396L12.5007 8.77295L22.9173 12.9396V22.3146C22.9173 22.5909 22.8076 22.8558 22.6122 23.0512C22.4169 23.2465 22.1519 23.3563 21.8757 23.3563H9.37565V17.398C9.37565 17.2396 9.33955 17.0834 9.27009 16.9411C9.20064 16.7988 9.09966 16.6742 8.97483 16.5768C8.85 16.4794 8.70461 16.4117 8.5497 16.3789C8.3948 16.3461 8.23445 16.3491 8.08086 16.3875L5.99753 16.9084C5.77227 16.9648 5.57233 17.0949 5.42946 17.2779C5.28659 17.461 5.20899 17.6866 5.20898 17.9188V23.3563H3.12565C2.84938 23.3563 2.58443 23.2465 2.38908 23.0512C2.19373 22.8558 2.08398 22.5909 2.08398 22.3146V12.9396Z",
    fill: "#6A4BFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaaba);
export default __webpack_public_path__ + "static/media/kaaba.609284427c9bc5b79256e29b9dc58fab.svg";
export { ForwardRef as ReactComponent };